export enum AddressFormNamespaces {
  Billing = 'billing',
  Shipping = 'shipping',
  Edit = 'edit',
}

export enum AddressFormFields {
  FirstName = 'firstname',
  LastName = 'lastname',
  Company = 'company',
  StreetLine1 = 'street[0]',
  StreetLine2 = 'street[1]',
  Postcode = 'postcode',
  City = 'city',
  Country = 'country_code',
  Region = 'region_id',
  VatNumber = 'vat_id',
  Phone = 'telephone',
  Selected = 'selected',
  FormVisibility = 'formVisibility',
}

export const ADDRESS_FIELD_KEYS = Object.values(AddressFormFields);

export const FORM_REVALIDATE_MODE = 'onBlur';
